module.exports = __webpack_public_path__ + "img/videoOff.fa9dd9ed.svg";